import { useContext } from 'react';

import { notifyBugsnag } from '~/common';

import { SearchInsightsContext } from '../SearchInsightsProvider';

export function useAlgoliaInsights() {
  const context = useContext(SearchInsightsContext);
  if (typeof context === 'undefined') {
    notifyBugsnag('useAlgoliaInsights must be used within a SearchInsightsContext');
  }
  return context;
}
